import React from 'react'
import { MapCardProps } from './types'
import { formatDate, getMapStatusLabel, getPreviewText } from './helpers'
import {
  Card,
  MapImage,
  CardContent,
  MapName,
  MapDescription,
  MapMeta,
  MapStatus,
} from './styled'

const MapCard: React.FC<MapCardProps> = ({ map, onClick }) => {
  return (
    <Card onClick={() => onClick(map)}>
      <MapImage $imageUrl={map.imageUrl}>
        {getPreviewText(!!map.imageUrl)}
      </MapImage>
      <CardContent>
        <MapName>{map.name}</MapName>
        {map.description && <MapDescription>{map.description}</MapDescription>}
        <MapMeta>
          <span>Updated {formatDate(map.updatedAt)}</span>
          <MapStatus $isPublic={map.isPublic}>
            {getMapStatusLabel(map.isPublic)}
          </MapStatus>
        </MapMeta>
      </CardContent>
    </Card>
  )
}

export { MapCard }
